module.exports = __webpack_public_path__ + "a16ef94293cfe4113235182fe4e9a560.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/graphics/woo-factory.svg
// module id = 623
// module chunks = 0